import { Mimic } from './mimic';

export class MimicFolder {
    id: string;
    vesselId: string;
    name: string;
    index: number;
}

export type MimicFolderViewData = {
    id: string;
    vesselId: string;
    name: string;
    index: number;
    mimicList: Mimic[];
    expanded?: boolean;
};

export enum RootItemType {
    folder = 'folder',
    mimic = 'mimic',
}

export type RootItem = {
    type: RootItemType;
    index: number;
    vesselId: string;
    folder?: MimicFolderViewData;
    mimic?: Mimic;
};

export enum RootDirectionOption {
    asc = 'ASC',
    desc = 'DESC',
}
